export default "__VITE_ASSET__Cn5Inbi4__"